import ComboboxWidget from './ComboboxWidget';
document.querySelectorAll('.combobox').forEach((element) => {
    element.comboboxWidget = new ComboboxWidget(element);
});
